function streaming(backendAxiosInstance) {
  async function getStreamingDetails(streamingId) {
    return backendAxiosInstance.get(`/contents/v1/streaming/${streamingId}`, {
      includeLanguage: true
    });
  }
  return { getStreamingDetails };
}

export { streaming as default };
//# sourceMappingURL=streaming.js.map
